import { create } from "zustand";
import { ApiTable } from "@/shared/api/table/api-table";

interface ServiceAccount {
  client_id: string;
  email: string;
}

interface ServiceAccountState {
  serviceAccount: ServiceAccount | null;
  isLoading: boolean;
  error: string | null;
  fetchServiceAccount: () => Promise<void>;
}

export const useServiceAccountStore = create<ServiceAccountState>((set) => ({
  serviceAccount: null,
  isLoading: false,
  error: null,
  fetchServiceAccount: async () => {
    set({ isLoading: true, error: null });
    try {
      const tableApi = new ApiTable();
      const response = await tableApi.getServiceAccount();
      set({ serviceAccount: response.data, isLoading: false });
    } catch (error) {
      console.error("Ошибка загрузки сервисного аккаунта:", error);
      set({
        error: "Не удалось загрузить сервисный аккаунт",
        isLoading: false,
      });
    }
  },
}));
